/**
 * Created by phatbass on 2/9/16.
 */

angular.module('far.search')
    .controller('SearchInstructorController', function ($timeout, $log, $http, $scope, form, autocomplete, userQualification, userAchievements, formsUtils) {
        var vm = {
            loaded: true,
            searchString: '',
            showRequestForm: false,
            showError: false,
            errorMessage: '',
            requestData: {
                instructor: null,
                message: null,
                fio: null,
                email: null,
                phone: null
            },
            searchForm: form('searchForm'),
            jobSeekersOnly: false,
            requestForm: form('requestForm'),
            responseOk: true,
            responseMessage: '',
            isLoading: false,
            instructors: {
                offset: 0,
                limit: 100,
                data: []
            },
            total: {
                count: 0,
                pages: null
            },
            firstload: true,
            isMember: false,
            formatDate: function(d) {
                var add0 = function(n) {
                    return n > 9 ? n : '0' + n;
                }
                return add0(d.getDate()) + '.' + add0(d.getMonth()+1) + '.' + d.getFullYear();
            },
            instructorPeriod: function(instructor) {
                if (instructor.instructor_period_start && instructor.instructor_period_end) {
                    return 'Готов работать в период с '
                        + this.formatDate(new Date(instructor.instructor_period_start))
                        + ' по '
                        + this.formatDate(new Date(instructor.instructor_period_end));
                } else {
                    return 'Готов работать';
                }
            },
            init: function(climberData) {
                vm.requestData.fio = climberData.fio;
                vm.requestData.email = climberData.email;
                vm.requestData.phone = climberData.phone;
                vm.isMember = climberData.isMember;
                vm.loadInstructors();
            },
            openRequestForm: function(instructorId) {
                if (vm.isMember) {
                    vm.requestData.instructor = instructorId;
                    vm.showRequestForm = true;
                    vm.responseMessage = '';
                    vm.requestData.message = '';
                } else {
                    vm.errorMessage = 'Отправка сообщений доступна только членам ФАР.';
                    vm.errorTitle   = 'Ошибка';
                    vm.showError = true;
                }
                return false;
            },
            submitRequest: function() {

                if (vm.isLoading) {
                    return false;
                }

                vm.isLoading = true;

                $http.post(Routing.generate('api_post_instructor_request'), vm.requestData).then(function (response) {
                    vm.responseMessage = 'Сообщение успешно отправлено.';
                    vm.responseOk = true;
                    vm.isLoading = false;
                }, function errorCallback(response) {
                    $log.error(response);
                    vm.responseMessage = 'Ошибка отправки сообщения.';
                    vm.responseOk = false;
                });
            },
            loadInstructors: function ( next ) {
                if (vm.isLoading) {
                    return false;
                }

                if ( !next ) {
                    vm.instructors.offset = 0;
                    vm.instructors.data = [];
                    vm.total.count = 0;
                    vm.total.pages = null;
                }

                var data = {
                    searchString: vm.searchString,
                    jobSeekersOnly: vm.jobSeekersOnly
                };
                //this.data = data;

                data['offset'] = vm.instructors.offset;
                data['limit'] = vm.instructors.limit;

                vm.isLoading = true;

                $http.get(Routing.generate('api_instructor_search', data)).then(function (response) {
                    vm.total.count = response.headers('X-Total-Count');
                    vm.total.pages = Math.ceil( vm.total.count / vm.instructors.limit );

                    for ( var id in response.data ) {
                        response.data[ id ]['url'] = Routing.generate('user_ascents_view', {userId: response.data[ id].id});
                        vm.instructors.data.push( response.data[ id ] );
                    }

                    vm.isLoading = false;
                    vm.firstload = false;
                }, function errorCallback(response) {
                    $log.error(response);

                    vm.isLoading = false;
                });
            },
            next: function () {
                vm.instructors.offset += vm.instructors.limit;
                vm.loadInstructors( true );
            },
            getTotalCount: function () {
                if (!vm.firstload) {
                    return formsUtils.numEnding( vm.total.count, ['Найден', 'Найдено', 'Найдено'] ) + ' ' + vm.total.count + ' ' + formsUtils.numEnding( vm.total.count, ['человек', 'человека', 'человек'] );
                }

                return '';
            }
        };

        vm.searchForm.addField('jobSeekersOnly', 'checkbox', {
            label: 'Показать желающих работать инструктором',
            options: {
                ngChange: function () {
                    $timeout(function() {
                        vm.loadInstructors();
                    });
                }
            }
        });

        vm.requestForm
            .addField('message', 'textarea', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Сообщение',
                    rows: 5,
                    class: 'form__item',
                }
            })
            .addField('fio', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Фамилия, имя, отчество',
                    class: 'form__item',
                }
            })
            .addField('email', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Email',
                    class: 'form__item',
                }
            })
            .addField('phone', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Телефон',
                    class: 'form__item',
                }
            });

        return vm;
    });
